<svg
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  [style.fill]="color ? color : ''"
  [style.width]="size"
  [style.height]="size"
>
  <use [attr.xlink:href]="absUrl + '#' + name"></use>
</svg>
